import { ReactComponent as MobileFiltersIcon } from './filters.svg';

export default MobileFiltersIcon;
